<template>
	<div class="element-container">
		<div class="tabs container-header">
			<button :class="['tab', currentTab === 'devices' && 'active']" @click="currentTab = 'devices'">
				<Icon name="tv" size="md" class="tab-icon"/>
				<span class="tab-label">Displays</span>
			</button>
			<button :class="['tab', currentTab === 'groups' && 'active']" @click="currentTab = 'groups'">
				<Icon name="tv-groups" size="md" class="tab-icon"/>
				<span class="tab-label">Groups</span>
			</button>
		</div>
		
		<div class="container-content">
			<div class="toolbar">
				<button class="refresh-btn" @click="refreshData" :disabled="isRefreshing" title="Refresh data">
					<Icon :name="isRefreshing ? 'loading' : 'refresh'" size="sm"/>
				</button>
				<button v-if="currentTab === 'devices'" class="add-btn primary-btn" @click="addDevice"
						title="Add">
					<Icon name="plus" size="lg" class="btn-icon"/>
					<!--				<span class="btn-text">Add Device</span>-->
				</button>
				<button v-else class="add-btn primary-btn" @click="addGroup">
					<Icon name="plus" size="lg" class="btn-icon"/>
					<!--				<span class="btn-text">Create Group</span>-->
				</button>
			</div>
			
			<div v-if="currentTab === 'devices'">
				<div v-if="store.pairedTVs.length" class="list">
					<ItemCard
							v-for="tv in store.pairedTVs"
							:key="tv.id"
							:title="tv.name"
							:status="tv.status"
							:subtitle="deviceSubtitle(tv)"
							:meta="defaultAppLabel(tv)"
							:selectable="true"
							v-model="selected[tv.id]"
							@open="controlTv(tv.id)"
							icon-name="tv"
					>
					</ItemCard>
				</div>
				<div v-else class="empty-state">
					<p class="empty-text">No displays paired yet.</p>
				</div>
			</div>
			
			<div v-else>
				<div v-if="store.groups.length" class="list">
					<ItemCard
						v-for="group in store.groups"
						:key="group.id"
						:title="group.name"
						:status="''"
						:subtitle="groupSubtitle(group)"
						:meta="`${group.member_count} device${group.member_count === 1 ? '' : 's'}`"
						action-label="Control"
						@action="controlGroup(group.id)"
						@open="controlGroup(group.id)"
						icon-name="tv-groups"
					>
					</ItemCard>
				</div>
				<div v-else class="empty-state">
					<p class="empty-text">No groups yet.</p>
				</div>
			</div>`
<!--			<div v-else>-->
<!--				<div v-if="store.groups.length" class="list">-->
<!--					<ItemCard-->
<!--							v-for="group in store.groups"-->
<!--							:key="group.id"-->
<!--							:title="group.name"-->
<!--							:subtitle="groupSize(group) === 1 ? '1 device' : `${groupSize(group)} devices`"-->
<!--							action-label="Control"-->
<!--							@action="controlGroup(group.id)"-->
<!--							@open="openGroup(group.id)"-->
<!--							icon-name="tv-groups"-->
<!--					>-->
<!--					</ItemCard>-->
<!--				</div>-->
<!--				<div v-else class="empty-state">-->
<!--					<p class="empty-text">No groups yet.</p>-->
<!--				</div>-->
<!--			</div>-->
		</div>
	</div>
</template>

<script setup>
import {onMounted, reactive, ref} from 'vue'
import {useRouter} from 'vue-router'
import {useMainStore} from '../store/main'
import ItemCard from './ItemCard.vue'
import Icon from "./Icon.vue";

const store = useMainStore()
const router = useRouter()

const currentTab = ref('devices')
const selected = reactive({})
const isRefreshing = ref(false)

onMounted(() => {
	console.log('[HOME:LIST] HomeList mounted')
	console.log('[HOME:LIST] Current user:', store.user)
	console.log('[HOME:LIST] User site_id:', store.user?.site_id)
	console.log('[HOME:LIST] Paired TVs count:', store.pairedTVs.length)
	console.log('[HOME:LIST] Groups count:', store.groups.length)
})

async function refreshData() {
	if (isRefreshing.value || !store.user?.site_id) return
	
	console.log('[HOME:LIST] Refreshing data...')
	isRefreshing.value = true
	
	try {
		await store.refreshSiteData()
		console.log('[HOME:LIST] Data refreshed successfully')
	} catch (error) {
		console.error('[HOME:LIST] Failed to refresh data:', error)
	} finally {
		isRefreshing.value = false
	}
}

function controlTv(tvId) {
	router.push(`/control/${tvId}`)
}

function groupSize(group) {
	if (!group.members) return 0
	return group.members.length
}

function controlGroup(groupId) {
	router.push(`/control/group/${groupId}`)
}

function openGroup(groupId) {
	alert('Group detail coming soon: ' + groupId)
}

function addDevice() {
	router.push('/pair')
}

function addGroup() {
	router.push('/groups/new')
}

function deviceSubtitle(tv) {
	const data = []
	
	// Group
	if (tv.group?.name) {
		data.push({icon: 'tv-groups', value: tv.group.name})
	}
	
	// Default App
	if (tv.default_app?.label && tv.default_app.key !== 'none') {
		data.push({icon: 'app', value: tv.default_app.label})
	}
	
	// ID
	if (tv.identifier_code) {
		data.push({icon: 'id', value: tv.identifier_code})
	} else {
		data.push({icon: 'id', value: 'Unidentified'})
	}
	
	return data // Return array instead of string
}

function groupSubtitle(group) {
	const data = []
	
	// Member count
	data.push({
		icon: 'tv',
		value: `${group.member_count} device${group.member_count === 1 ? '' : 's'}`
	})
	
	// Default app if exists
	if (group.default_app?.label && group.default_app.key !== 'none') {
		data.push({
			icon: 'app',
			value: group.default_app.label
		})
	}
	
	return data // Return array of objects instead of strings
}

function defaultAppLabel(tv) {
	if (!tv.default_app) return ''
	return tv.default_app.label || ''
}
</script>

<style scoped>
.tabs {
	display: flex;
	width: 100%;
	gap: 8px;
	background: var(--color-popup);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-lg);
	padding: var(--spacing-lg);
	position: sticky;
	top: 0;
	z-index: 1;
}

.tab {
	flex: 1;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 10px 12px;
	border: none;
	border-radius: 8px;
	background: transparent;
	color: var(--color-text, #fff);
	font-weight: 600;
	opacity: 0.7;
}

.tab.active {
	background: var(--color-primary);
	opacity: 1;
}

.tab-icon {
	font-size: 18px;
}

.toolbar {
	display: flex;
	justify-content: flex-end;
	width: 98%;
	gap: var(--spacing-sm); /* Add spacing between buttons */
	spa-right: var(--spacing-lg);
}

.refresh-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 10px 12px;
	background: var(--color-popup);
	color: var(--color-text);
	border: var(--border-thin) var(--color-border);
	border-radius: 10px;
	cursor: pointer;
	transition: all 0.2s ease;
}

.refresh-btn:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.refresh-icon {
	width: 18px;
	height: 18px;
}

.refresh-icon.spinning {
	animation: spin 1s linear infinite;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

.add-btn {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 10px 12px;
	background: var(--color-primary, #2d7ff9);
	color: #fff;
	border: none;
	border-radius: 10px;
	font-weight: 700;
}

.add-icon {
	font-size: 18px;
	line-height: 1;
}

.list {
	display: grid;
	gap: 10px;
}

.empty-state {
	flex: 1;
	display: grid;
	place-items: center;
	text-align: center;
	padding: 48px 12px;
}

.empty-text {
	font-size: 16px;
	color: var(--color-subtle, #9aa0a6);
	margin-bottom: 12px;
}

.primary {
	background: var(--color-primary, #2d7ff9);
	color: #fff;
	border: none;
	padding: 10px 16px;
	border-radius: 10px;
	font-weight: 700;
}


/* Modern button styles */
.primary-btn {
	background: var(--color-primary);
	color: white;
	border: none;
	border-radius: var(--border-radius-md);
	padding: 0.75rem 1rem;
	font-weight: var(--font-weight-medium);
	display: inline-flex;
	align-items: center;
	gap: 0.5rem;
	transition: all var(--transition-fast);
	box-shadow: var(--shadow-sm);
}

.primary-btn:active {
	transform: translateY(0);
}

.btn-icon {
	width: 18px;
	height: 18px;
}

.btn-text {
	font-size: var(--font-size-sm);
}

.tabs {
	background: var(--color-surface-elevated-2);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-xl);
	padding: var(--spacing-sm);
	gap: 0.25rem;
}

.tab {
	background: transparent;
	border: var(--border-thin) var(--color-border);;
	/*border-radius: calc(var(--border-radius-lg) - var(--spacing-sm)) !important; */
	padding: var(--spacing-md) var(--spacing-lg);
	transition: all var(--transition-fast);
	font-weight: var(--font-weight-medium);
}

.tab.active {
	background: var(--color-primary);
	color: white;
	box-shadow: var(--shadow-sm);
}

.tab-icon {
	width: 20px;
	height: 20px;
}

.tab-label {
	font-size: var(--font-size-sm);
}

.toolbar {
	gap: 0.75rem;
}

.refresh-btn {
	background: var(--color-surface-elevated);
	border: 1px solid var(--color-border);
	border-radius: var(--border-radius-md);
	padding: 0.75rem;
	transition: all var(--transition-fast);
}

.refresh-icon {
	width: 20px;
	height: 20px;
}

.refresh-icon.spinning {
	animation: spin 1s linear infinite;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}
</style>